// Numbers
const DATE_STRING_REGEX = /\d{4}-\d{2}-\d{2}/;
export const isDateString = (input) => DATE_STRING_REGEX.test(input);
